import { CompletedTransaction } from '@/types/api/bankid/v2/transaction';
import { CircleCheckBig } from 'lucide-react';
import * as React from 'react';

type TransactionCompletedProps = {};

export function TransactionCompleted({}: TransactionCompletedProps) {
  const [timeoutReached, setTimeoutReached] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setTimeoutReached(true);
    }, 5000); // 5 seconds

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <CircleCheckBig size={64} color="#10b981" aria-hidden />

      <h3 className="text-xl leading-relaxed font-semibold">BankID-Verifiering klar!</h3>

      <p className="text-base leading-7 text-gray-700 dark:text-gray-300 text-center">
        {timeoutReached
          ? 'Stäng denna flik och gå tillbaka till den du var i tidigare.'
          : 'Du omdirigeras, vänta ett ögonblick...'}
      </p>
    </>
  );
}
